/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Left_Spare_Ibex_SpinInputs */

const fr_left_spare_ibex_spin = /** @type {(inputs: Left_Spare_Ibex_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouté le`)
};

/**

* @param {Left_Spare_Ibex_SpinInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const left_spare_ibex_spin = /** @type {((inputs?: Left_Spare_Ibex_SpinInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Left_Spare_Ibex_SpinInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_left_spare_ibex_spin(inputs)
});